import React from 'react';
import Icon from '../../../components/AppIcon';
import { format, differenceInDays } from 'date-fns';

const UpcomingDeadlines = ({ events }) => {
  const sortedDeadlines = [...events]?.sort((a, b) => new Date(a.date) - new Date(b.date))?.slice(0, 5);

  const getDaysUntil = (date) => {
    return differenceInDays(new Date(date), new Date());
  };

  const getUrgencyColor = (daysUntil) => {
    if (daysUntil <= 3) return 'text-error';
    if (daysUntil <= 7) return 'text-warning';
    return 'text-foreground';
  };

  const getUrgencyBg = (daysUntil) => {
    if (daysUntil <= 3) return 'bg-error/10 border-error';
    if (daysUntil <= 7) return 'bg-warning/10 border-warning';
    return 'bg-card border-border';
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="AlertCircle" size={20} color="var(--color-error)" />
        <h3 className="font-heading font-semibold text-foreground">Upcoming Deadlines</h3>
      </div>
      <div className="space-y-2">
        {sortedDeadlines?.length === 0 ? (
          <div className="text-center py-6">
            <Icon name="CheckCircle" size={32} color="var(--color-success)" className="mx-auto mb-2" />
            <p className="text-sm text-muted-foreground">No upcoming deadlines</p>
          </div>
        ) : (
          sortedDeadlines?.map((deadline) => {
            const daysUntil = getDaysUntil(deadline?.date);
            const isPast = daysUntil < 0;

            return (
              <div
                key={deadline?.id}
                className={`p-3 rounded-lg border ${getUrgencyBg(daysUntil)}`}
              >
                <div className="flex items-start gap-2">
                  <Icon 
                    name="Calendar" 
                    size={16} 
                    className={getUrgencyColor(daysUntil)} 
                  />
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-foreground truncate">
                      {deadline?.title}
                    </p>
                    <p className="text-xs text-muted-foreground mt-1">
                      {format(new Date(deadline.date), 'MMM d, yyyy')}
                    </p>
                    {deadline?.description && (
                      <p className="text-xs text-muted-foreground mt-1">
                        {deadline?.description}
                      </p>
                    )}
                    <div className={`text-xs font-medium mt-2 ${getUrgencyColor(daysUntil)}`}>
                      {isPast ? (
                        'Overdue'
                      ) : daysUntil === 0 ? (
                        'Due today'
                      ) : daysUntil === 1 ? (
                        'Due tomorrow'
                      ) : (
                        `${daysUntil} days remaining`
                      )}
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default UpcomingDeadlines;